import React from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaUserCheck, FaShieldAlt } from "react-icons/fa";
import "./HeroSection.css";

function HeroSection({ stats, isLoggedIn }) {  // ✅ devref removed
  const id = localStorage.getItem('user_id');

  return (
    <div className="hero-section-luxury" id="hero">
      <div className="hero-overlay-luxury"></div>
      
      {/* Floating Emojis Background */}
      <div className="hero-bg-shapes">
        {["💕", "💝", "💖", "💗", "💓", "💘", "🌹", "✨"].map((e, i) => (
          <div key={i} className={`floating-emoji fe-${i}`}>{e}</div>
        ))}
      </div>

      <div className="hero-split-layout">
        
        {/* LEFT: Text Content */}
        <div className="hero-text-side">
          <div className="hero-badge-luxury">
            <span className="badge-dot"></span>
            Welcome to Community Rishtey
          </div>

          <h1 className="hero-title-luxury">
            Find Your <span className="hero-highlight-luxury">Perfect Match</span>
          </h1>

          <p className="hero-subtitle-luxury">
            "Your perfect life partner is waiting, and we are here to bring you together.
            Join our trusted community and make your journey to love memorable and joyful."
          </p>

          <div className="hero-actions-luxury">
            <div className="hero-links-luxury">
              {id == null ? (
                <>
                  <Link to="/User_Reg" className="hero-link">  {/* ✅ Simple - no devref */}
                    Sign Up
                  </Link>
                  <span className="hero-link-separator">|</span>
                  <Link to="/User_Login" className="hero-link">
                    Login
                  </Link>
                </>
              ) : (
                <Link to="/Home_Page_Log" className="hero-link">
                  View Matches
                </Link>
              )}
            </div>
          </div>

          {/* Stats Chips */}
          <div className="hero-stats-inline">
            <div className="hero-stat-chip">
              <FaUsers className="hsc-icon" />
              <div>
                <strong>{stats.total}+</strong>
                <span>Members</span>
              </div>
            </div>
            <div className="hero-stat-chip">
              <FaUserCheck className="hsc-icon" />
              <div>
                <strong>{stats.verified}+</strong>
                <span>Verified</span>
              </div>
            </div>
            <div className="hero-stat-chip">
              <FaShieldAlt className="hsc-icon" />
              <div>
                <strong>100%</strong>
                <span>Secure</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT: Couple Image */}
        <div className="hero-image-side">
          <div className="hero-img-wrapper">
            <img
              src="https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg?auto=compress&cs=tinysrgb&w=600&h=600&fit=crop"
              alt="Happy Couple"
              className="hero-couple-img"
            />
            <div className="hero-img-ring"></div>
          </div>

          {/* Floating Mini Badges */}
          <div className="hero-mini-badge hmb-1">
            <span>💍</span> 15K+ Matches
          </div>
          <div className="hero-mini-badge hmb-2">
            <span>❤️</span> Trusted
          </div>
          <div className="hero-mini-badge hmb-3">
            <span>⭐</span> 4.9 Rating
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;